<template>
  <div class="relative w-full">
    <!-- Link here -->
    <div class="copy-holder" :class="isIconMuted && 'is-muted'">
      <p :style="customTextStyles">{{ text }}</p>
    </div>

    <!-- Copy Icon -->
    <div
      class="icon-region"
      :class="isIconMuted && 'is-muted'"
      @click="$emit('click')"
    >
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="17" height="19.3538" rx="8.5" fill="#F5F2EE" />
        <rect
          x="3.47754"
          y="0.5"
          width="13.0224"
          height="15.8269"
          rx="1.5"
          stroke="black"
        />
        <rect
          x="0.5"
          y="3.02734"
          width="13.0224"
          height="15.8269"
          rx="1.5"
          fill="white"
          stroke="black"
        />
        <line x1="3" y1="8.5" x2="11" y2="8.5" stroke="black" />
        <line x1="3" y1="11.5" x2="11" y2="11.5" stroke="black" />
        <line x1="3" y1="14.5" x2="11" y2="14.5" stroke="black" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    isIconMuted: {
      type: Boolean,
      default: false
    },
    customTextStyles: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.copy-holder {
  height: 53px;
  width: 100%;
  border: 1px solid #232220;
  padding-left: 20px;
  border-radius: 56px;
  display: flex;
  align-items: center;

  &.is-muted {
    height: 48px;
  }

  p {
    text-align: left;
    font-size: 0.813rem;
    color: $onyx;
    max-width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.icon-region {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 18px;
  background: $onyx;
  border: 1px solid $onyx;
  border-radius: 56px;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.is-muted {
    background-color: transparent;
    border: none;

    svg {
      width: 12px;
    }
  }
}

@media screen and (max-width: 630px) and (min-width: 350px) {
  .copy-holder {
    p {
      text-align: left;
      font-size: 0.813rem;
      color: $onyx;
      max-width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
